import { BookOpen, ArrowRight, X } from "lucide-react";
import { motion } from "framer-motion";

export const OnboardingModal = ({ onClose, onNavigate, lang, organ1Unlocked = true }) => {
  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center">
      <div className="fixed inset-0 bg-black/30 backdrop-blur-sm" onClick={onClose} />
      <motion.div
        initial={{ opacity: 0, scale: 0.95, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        className="relative bg-white dark:bg-[#111] rounded-[20px] shadow-2xl w-[90%] max-w-[420px] overflow-hidden"
        data-testid="onboarding-modal"
      >
        {/* Close */}
        <button onClick={onClose} className="absolute top-4 right-4 p-1.5 rounded-full text-[rgba(0,0,0,0.3)] hover:text-[rgba(0,0,0,0.6)] hover:bg-[rgba(0,0,0,0.04)] transition-colors z-10" data-testid="onboarding-skip">
          <X size={18} />
        </button>

        {/* Content */}
        <div className="p-8 text-center">
          <div className="w-16 h-16 rounded-[20px] bg-[#0A0A0A] flex items-center justify-center mx-auto mb-5">
            <BookOpen size={28} className="text-[#2563EB]" />
          </div>

          <h2 className="text-xl font-bold text-[#0A0A0A] dark:text-white mb-2" style={{ fontFamily: 'Inter, sans-serif' }}>
            {lang === 'en' ? 'Welcome to BSS Portal!' : 'Selamat Datang ke BSS Portal!'}
          </h2>

          <p className="text-sm text-[rgba(0,0,0,0.5)] dark:text-[rgba(255,255,255,0.5)] leading-relaxed mb-6">
            {organ1Unlocked
              ? (lang === 'en'
                ? 'Start your learning journey by reading Organ 1. You can complete your profile, take quizzes, and join the community anytime.'
                : 'Mulakan perjalanan pembelajaran anda dengan membaca Organ 1. Anda boleh lengkapkan profil, jawab quiz, dan sertai komuniti bila-bila masa.')
              : (lang === 'en'
                ? 'Organ content unlocks when you attend physical sessions. Register for a session, scan the attendance QR, and your content opens instantly.'
                : 'Kandungan Organ dibuka apabila anda hadiri sesi fizikal. Daftar sesi, imbas QR kehadiran, dan kandungan anda terus terbuka.')}
          </p>

          {/* CTA */}
          <button
            onClick={() => onNavigate(organ1Unlocked ? 'organ' : 'events')}
            className="w-full py-3.5 bg-[#0A0A0A] text-white rounded-full font-semibold text-sm flex items-center justify-center gap-2 hover:translate-y-[-1px] hover:shadow-lg active:scale-[0.97] transition-all duration-200"
            data-testid="onboarding-action"
          >
            {organ1Unlocked
              ? (lang === 'en' ? 'Start Reading Organ 1' : 'Mula Baca Organ 1')
              : (lang === 'en' ? 'View Sessions & Events' : 'Lihat Sesi & Event')}
            <ArrowRight size={16} />
          </button>

          <button
            onClick={onClose}
            className="mt-3 text-xs text-[rgba(0,0,0,0.3)] hover:text-[rgba(0,0,0,0.5)] transition-colors"
            data-testid="onboarding-skip-text"
          >
            {lang === 'en' ? 'Skip, explore on my own' : 'Lewati, saya nak explore sendiri'}
          </button>
        </div>
      </motion.div>
    </div>
  );
};
